<template>
    <div v-select-text="value" style="width: 700px; margin:0 auto; position: relative;">
        <img style="width: 100%" src="./i1.png"/>
        <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; color: transparent;">
            <span style="position: absolute;top: 10px; font-weight: bold; right: 70px; font-size: 35px;">ООО  "ДИОСТРОЙ-ИНВЕСТ"</span>
            <span style="position: absolute;top: 66px;line-height: 21px;font-weight: bold;left: 200px;font-size: 17px;">ЖИЛОЙ</span>
            <span> </span>
            <span style="position: absolute;top: 82px;font-weight: bold;left: 178px;font-size: 17px;">КОМПЛЕКС</span>
            <span> </span>
            <span style="position: absolute;font-weight: bold;top: 33px; left: 278px;font-size: 71px;">ФЛАГМАН</span>
            <span> </span>
            <span style="position: absolute;top: 111px;font-weight: bold;letter-spacing: -0.3px;font-size: 32px;left: 72px;">ДОМ, ОТКРЫВАЮЩИЙ ГОРИЗОНТЫ!</span>
            <span> </span>
            <span style="position: absolute;font-weight: bold;top: 235px;left: 348px;letter-spacing: -0.1px;">Строительная фирма</span>
            <span> </span>
            <span style="position: absolute;font-weight: bold;top: 253px;left: 349px;font-size: 19px;">ООО Диострой-Инвест"</span>
            <span> </span>

            <span style="position: absolute;font-weight: bold;top: 363px;left: 32px;font-size: 24px;">ул. Ивана Сусанина, д.41</span>
            <span> </span>

            <span style="position: absolute;font-weight: bold;top: 415px;left: 24px;font-size: 29px;">8(4942)</span>
            <span style="position: absolute;font-weight: bold;top: 400px;left: 131px;font-size: 47px;">31-52-52</span>
            <span> </span>

            <span style="position: absolute;font-weight: bold;top: 447px;left: 23px;font-size: 39px;">8-910-016-52-52</span>
            <span> </span>
            <span style="position: absolute;font-weight: bold;top: 485px;left: 23px;font-size: 29px;">kastroma41@yandex.ru</span>
            <span style="position: absolute;font-weight: bold;top: 526px;left: 54px;font-size: 18px;">Проектная декларация размещена на сайте</span>
            <span style="position: absolute;font-weight: bold;top: 520px;left: 436px;font-size: 26px;">www.diostroy.com </span>
        </div>
    </div>
</template>
<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array]
        },
        directives: {
            SelectText
        }
    }
</script>